<div class="popover__wrapper" *ngIf="loaded">
	<a href="#" onclick="return false;" >
		<ng-container *ngFor="let typeQualification of displayedTypesQualifications">
		
		  <div *ngIf="!(isSolaire && typeQualification.id === hauteurQualificationId)"
		       [ngClass]="['indicator', typesClassesQual[typeQualification.id]]"
		       [style.display]="'inline-block'"
		       [style.padding-right]="spacing">
		
		    <i [ngClass]="[
		          typeQualification.iconClass,
		          (typeQualification.iconClass.trim() === 'fa fa-bolt fa-2x'
		           && (shouldBlink$ | async) === 'blink_icon')
		           ? 'blink_icon' : ''
		        ]"
		       [title]="typeQualification.title">
		    </i>
		
		    <br />
		    <span>{{ typeQualification.text || '\u00A0' }}</span>
		  </div>
		
		</ng-container>
	</a>

	<div class="popover__content">
		<div class="panel panel-default modal-sm">
			<div class="panel-heading" role="document">
				<h3>D&eacute;tails habilitations</h3>
			</div>
			<div class="panel-body">
				<div class="section" *ngIf="typesHabilitations.length === 0">
					<span class="title">Pas d'habilitation connue pour cet intervenant</span><br />
				</div>
				<div *ngIf="typesHabilitations.length > 0">
					<div class="section" *ngFor="let typeHabilitation of typesHabilitations">
						<ng-container *ngIf="!(isSolaire && typeHabilitation.qualificationTypeId === hauteurQualificationId)">
							<span [class]="typeHabilitation.valid ? 'title' : 'red-title'"> {{ typeHabilitation.nomType }}</span>
							<span [class]="typeHabilitation.valid ? 'title' : 'red-title'" *ngIf="typeHabilitation.codeParc"> ({{ typeHabilitation.codeParc }})</span>
							<br />
							<span class="field">{{ typeHabilitation.qualificationCodes }}</span>
							<br />
							<span *ngIf="typeHabilitation.actif" class="field">Expire le: {{ typeHabilitation.dateFin | date: 'dd/MM/yyyy'}}</span>
							<span *ngIf="!typeHabilitation.actif" class="field">Annul&eacute;</span>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="popover__wrapper" *ngIf="extended && loaded">
	<a href="#" onclick="return false;" >
		<div *ngFor="let typePdp of displayableTypes"
			[ngClass]="['indicator', typeClassesPdp ? typeClassesPdp[typePdp.id] : '']"
			[style.display]="'inline-block'"
			[style.padding-right]="spacing"
			>
			<i
				[class]="typePdp.iconClass"
				[title]="typePdp.iconTitle">
			</i>
			<br/>
			{{ typePdp.iconText ? typePdp.iconText : '&nbsp;' }}
		</div>
	</a>
	<div class="popover__content">
		<div class="panel panel-default modal-sm">
			<div class="panel-heading" role="document">
				<h3>D&eacute;tails {{ entreprise?.documentApplicable === 'Both' ? 'PDP et PA' : (entreprise?.documentApplicable === 'PlanPrevention' ? 'PDP' : 'PA') }}</h3>
			</div>
			<div class="panel-body" *ngIf="entreprise?.documentApplicable === 'PlanPrevention' || entreprise?.documentApplicable === 'Both'">
				<div class="section" *ngFor="let tp of displayableTypes">
					<div *ngIf="tp.type !== typeDocuments.PA">
						<span [ngClass]="['title', (typeClassesPdp ? typeClassesPdp[tp.id] : '')]"> {{ tp.sectionTitle }} </span>
						<br />
						<div *ngIf="relevantPdpSignesByType[tp.id] && relevantPdpSignesByType[tp.id].length === 0">
							<span class="field">Aucun pdp valide et sign&eacute; pour cet intervenant</span>
						</div>
						<div *ngFor="let signedPdP of relevantPdpSignesByType[tp.id]">
							<span class="field numero">{{ signedPdP.numeroPdp }}</span>
							<br />
							<span class="field">Expire le: {{ signedPdP.finValidite | localDateToDate | date: 'dd/MM/yyyy'}}</span>
							<br />
						</div>
					</div>
				</div>
			</div>
			
			<div class="panel-body" *ngIf="intervenantPaInfo && intervenantPaInfo.entreprisePa && (entreprise?.documentApplicable === 'PersonneAvertie' || entreprise?.documentApplicable === 'Both')">
				<div class="section" *ngFor="let tp of displayableTypes">
					<div *ngIf="tp.type === typeDocuments.PA">
						<span [ngClass]="['title', (intervenantPaInfo.paInfos.length ? 'text-success' : 'text-danger')]"> {{ tp.sectionTitle }} </span>
						<br />
						<div *ngIf="!intervenantPaInfo.paInfos || intervenantPaInfo.paInfos.length === 0">
							<span class="field">Aucun document PA valide et sign&eacute; pour cet intervenant</span>
						</div>
						<div *ngFor="let signedPa of intervenantPaInfo.paInfos">
							<span class="field numero">{{ signedPa.numero }}</span>
							<br />
							<span class="field">Expire le: {{ signedPa.dateFin | localDateToDate | date: 'dd/MM/yyyy'}}</span>
							<br />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>